import { motion } from 'framer-motion'
import { Trash2, Download, X } from 'lucide-react'
import Button from './Button'

const BulkActions = ({ selected, onDelete, onExport, onClear, resourceName = 'items' }) => {
  if (selected.length === 0) return null

  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      className="glass-card p-4 mb-4 flex flex-col sm:flex-row items-center justify-between gap-3"
    >
      <div className="flex items-center gap-3">
        <span className="text-sm font-semibold text-gray-700">
          {selected.length} {resourceName} selected
        </span>
        <button
          onClick={onClear}
          className="text-gray-500 hover:text-gray-700 transition-colors"
        >
          <X size={18} />
        </button>
      </div>
      <div className="flex gap-2">
        {onExport && (
          <Button variant="secondary" onClick={() => onExport(selected)} className="flex items-center gap-2">
            <Download size={18} />
            Export
          </Button>
        )}
        {onDelete && (
          <Button
            variant="secondary"
            onClick={() => onDelete(selected)}
            className="flex items-center gap-2 text-red-600 hover:text-red-700"
          >
            <Trash2 size={18} />
            Delete
          </Button>
        )}
      </div>
    </motion.div>
  )
}

export default BulkActions

